import { X } from "lucide-react";
import { Button } from "@/components/ui/button";

interface ResetFiltersButtonProps {
  /** Whether any filters (AG Grid column filters or custom dropdowns) are currently active */
  hasActiveFilters: boolean;
  /** Callback to reset all filters */
  onReset: () => void;
}

/**
 * A reusable "Reset Filters" button that clears all applied filters on a grid.
 * Only visible when filters are active.
 */
const ResetFiltersButton = ({ hasActiveFilters, onReset }: ResetFiltersButtonProps) => {
  if (!hasActiveFilters) return null;

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={onReset}
      className="gap-1 text-muted-foreground"
    >
      <X className="w-3.5 h-3.5" />
      Clear
    </Button>
  );
};

export default ResetFiltersButton;
